import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class EnvProdService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '0',
      _env: 'prod',
      _apiUrl: 'https://api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer: 'https://pcisadb2c.b2clogin.com/d3a1123b-2b73-4820-9c60-d42ed97a6280/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: 'd3a1123b-2b73-4820-9c60-d42ed97a6280',
      _scope: 'openid profile https://pcisadb2c.onmicrosoft.com/api/pcis.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://login.p-cis.com/',
      _signInURL: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint: 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://pcisadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9ab0',
      _intercomAppId: 'bqgvwybf'
      
    };
  }
}
